import { useMediaQuery } from "react-responsive";

export const DesktopOnly = ({ children }) => {
	const isDesktop = useMediaQuery({
		maxWidth: 1199,
		minWidth: 992
	});
	return isDesktop ? children : null;
};

export const Desktop = ({ children }) => {
	const isDesktop = useMediaQuery({
		minWidth: 992
	});
	return isDesktop ? children : null;
};

export const LargeDesktop = ({ children }) => {
	const isLargeDesktop = useMediaQuery({ minWidth: 1200 });
	return isLargeDesktop ? children : null;
};

export const Tablet = ({ children }) => {
	const isTablet = useMediaQuery({
		maxWidth: 991,
		minWidth: 768
	});
	return isTablet ? children : null;
};

export const TabletUp = ({ children }) => {
	const isTablet = useMediaQuery({
		minWidth: 768
	});
	return isTablet ? children : null;
};

export const Mobile = ({ children }) => {
	const isMobile = useMediaQuery({ maxWidth: 767 });
	return isMobile ? children : null;
};

export const Default = ({ children }) => {
	const isNotMobile = useMediaQuery({ minWidth: 768 });
	return isNotMobile ? children : null;
};
